module.exports = __webpack_public_path__ + "img/666.11115586.jpg";